var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.6938 12.5219C60.6938 12.5219 80.1219 23.6282 85.2063 41.2719C89.7875 57.2094 86.1188 64.8157 86.1188 64.8157C88.4617 67.3684 90.3078 70.3359 91.5625 73.5657C92.8227 75.6409 93.5632 77.9897 93.721 80.4124C93.8788 82.8352 93.4492 85.2602 92.4688 87.4813C92.4688 87.4813 92.1562 80.9813 82.4688 79.6344C73.5906 78.3844 70.3625 87.0282 53.4062 86.6094C44.0112 86.4304 34.8026 83.9559 26.5832 79.4018C18.3638 74.8476 11.3832 68.352 6.25 60.4813C14.5344 65 25.3875 72.0157 38.9031 70.9375C52.4188 69.8594 55.2406 65.7063 55.2406 65.7063C40.0484 53.6843 26.601 39.609 15.2844 23.8844C25.9094 32.775 52.2281 50.4688 51.6156 50.0188C41.9887 40.6121 33.1808 30.4023 25.2875 19.5C25.2875 19.5 64.775 51.9657 67.9531 51.7594C69.2594 49.0688 76.0125 35.1407 60.6906 12.5188L60.6938 12.5219Z",
    fill: "url(#paint0_linear_166_124)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_166_124",
    x1: 51.375,
    y1: 42.5219,
    x2: 49.723,
    y2: 87.5189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD2221"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwift);
export default __webpack_public_path__ + "static/media/swift.175d0c35e2ff460765147d537373a6c2.svg";
export { ForwardRef as ReactComponent };